import { useState } from 'react';
import { AnalyticsDateRangePopupForm } from './AnalyticsDateRangePopupForm';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';
import { Button } from 'src/components/ui/button';
import type { CustomDateRangeValues } from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsCoCustomer.types';

export type AnalyticsDateRangeTheme = 'agent' | 'customer';

export const AnalyticsDateRangePopup = ({
  open,
  setOpen,
  submitDateFilter = (_data: CustomDateRangeValues) => {},
  dateDefault,
  theme,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  submitDateFilter?: (data: CustomDateRangeValues) => void;
  dateDefault: CustomDateRangeValues['date'];
  theme: AnalyticsDateRangeTheme;
}) => {
  const [canSubmit, setCanSubmit] = useState(false);

  const submit = (formData: CustomDateRangeValues) => {
    submitDateFilter(formData);
    setOpen(false);
  };

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className={'text-ebony'}>Calendar</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <AnalyticsDateRangePopupForm
            onSubmit={submit}
            dateDefault={dateDefault}
            onCanSubmitChange={setCanSubmit}
          />
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="ghost">Cancel</Button>
          </DialogClose>
          <Button type="submit" form="aply-date-filter-form" disabled={!canSubmit}>
            Done
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
